export { default as DetalleTurnoFinalizado } from "./DetalleTurnoFinalizado";
